<template>
  <v-app id="inspire">
    <v-app-bar 
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    dense app dark color="blue darken-4">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title style="width: 400px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">MyPlanilla - Boleta Pago</span>
      </v-toolbar-title>
      <v-spacer />
      <v-btn v-if="logueado" text rounded @click="salir">
        <v-icon>mdi-exit-to-app</v-icon>Salir
      </v-btn>
      <v-btn v-else icon :to="{ name: 'Login' }">
        <v-icon>mdi-apps</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      color="blue lighten-5"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      v-if="logueado"
    >
      <v-list dense>
        <template>
          <v-list-item :to="{ name: 'Home' }" link class="ps-10">
            <v-list-item-content>
              <v-list-item-title>Inicio</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'cambiarPassword' }" link class="ps-10">
            <v-list-item-content>
              <v-list-item-title>Cambiar Contraseña</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'descargarBoletaPago' }" link class="ps-10">
            <v-list-item-content>
              <v-list-item-title>Boleta Pago</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-main :style="colorFondo">
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>

    <v-footer height="auto" class="pa-0" :fixed="footerFixed">
      <v-card flat tile width="100%" class="blue darken-1 text-right ma-0 pa-0">
        <v-card-text class="white--text ma-0 pa-1 pr-4">
          {{ new Date().getFullYear() }} — MyPlanilla - Modulo Boleta de Pago
          Ver 2.0.0
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import backgroundUrl from "./assets/fondo-planilla.jpg";
export default {
  name: "App",
  props: {
    source: String,
  },
  components: {},
  data: () => ({
    drawer: null,
    dialog: false,
    backgroundUrl,
    footerFixed: true,
  }),
  computed: {
    logueado() {
      return this.$store.state.usuario;
    },
    colorFondo() {
      let img = `${backgroundUrl}`;
      return {
        background:
          "linear-gradient(rgba(197,202,233,.75), rgba(159,168,218,.75)), url(" +
          img +
          ") no-repeat",
        "background-size": "cover",
      };
    },
  },
  mounted() {
    this.$store.dispatch("autoLogin");
  },
  methods: {
    salir() {
      this.$store.dispatch("salir");
    },
  },
};
</script>

<style>
.my-input input {
  text-transform: uppercase;
}
.center-input input {
  text-align: center;
}
</style>

